import { helpers } from "../coderunner/__core";
import { tb2definitions } from "../migration/data/tb2definitions"


export const migrateFormats = () => {
  helpers.log(`definitions imported: ${tb2definitions.length}`)

  const withFormat = tb2definitions.filter((def) => def.format !== undefined && def.format.length > 0)
  helpers.log(`definitions with format: ${withFormat.length}`)

  helpers.log("Here are the formats we need to migrate:")
  const formatData = withFormat.map((def) => ({
    placeholder: def.placeholder,
    format: def.format,
  }))

  helpers.table(formatData)
}